module.exports = __webpack_public_path__ + "static/media/arrow-right-filled.cd5adbc9.svg";